/* tslint:disable:import-spacing no-inferrable-types variable-name align no-trailing-whitespace */

import {SchemaSpecification} from './schema.specification';
import {
  Diversion
} from './diversion';

export class DiversionSchema extends SchemaSpecification {

  constructor() {

    super();

    this.multiRow = true;

    this.jsonSpec = `{
      "diversions": {
        "schema": {
          "fields": [
            {
              "name": "train_id",
              "title": "client generated id for train eligible for diversion",
              "type": "integer",
              "col": 1,
              "constraints": {
                  "required": true
              }
            },
            {
              "name": "work_block_id",
              "title": "ID of work block to which this diversion applies",
              "type": "integer",
              "col": 2,
              "constraints": {
                  "required": true
              }
            },
            {
              "name": "diversion_id",
              "title": "ID of the diversion group",
              "type": "integer",
              "col": 3,
              "constraints": {
                  "required": true
              }
            },
            {
              "name": "name",
              "title": "human label/name for diversion group of trains",
              "type": "string",
              "col": 4,
              "constraints": {
                  "required": true
              }
            },
            {
              "name": "description",
              "title": "human description of diversion group of trains",
              "type": "string",
              "col": 5
            },
            {
              "name": "from_dp",
              "title": "ID of Decision point on West end (high MP) of diversion",
              "type": "integer",
              "col": 6,
              "constraints": {
                  "required": true
              }
            },
            {
              "name": "from_link_id",
              "title": "ID of link to use at from DP",
              "type": "integer",
              "col": 7
            },
            {
              "name": "to_dp",
              "title": "ID of Decision point on East end (low MP) of diversion",
              "type": "integer",
              "col": 8,
              "constraints": {
                  "required": true
              }
            },
            {
              "name": "to_link_id",
              "title": "ID of link to use at to DP",
              "type": "integer",
              "col": 9
            },
            {
              "name": "diversion_time",
              "title": "Hours mean travel time on diversion",
              "type": "float",
              "col": 10,
              "constraints": {
                  "required": true
              }
            },
            {
              "name": "diversion_stdev",
              "title": "Hours stdev travel time on diversion",
              "type": "float",
              "col": 11,
              "constraints": {
                  "required": true
              }
            }
          ]
        },
        "dataType": "table",
  "data": [
  ]
 }
}`;

    super.cache();
  }

  /** convert the given object to data table row(s), only properties that match field names will be created. */
  public override toRow(object: any): any[] {

    const diversion: Diversion = object as Diversion;
    const      rows:     any[] = [];

    /* each diversion group has some number of trains, which are all going to be taking that diversion */

    for (const train of diversion._trains) {

      if (

        !diversion._work ||
        !diversion._from ||
        !diversion._fromTrack ||
        !diversion._to ||
        !diversion._toTrack) {

        continue;
      }

      const proxy: any = {
        train_id:        train._id,
        work_block_id:   diversion._work._id,
        diversion_id:    diversion._id,
        from_dp:         diversion._from._id,
        from_link_id:    diversion._fromTrack._id,
        to_dp:           diversion._to._id,
        to_link_id:      diversion._toTrack._id,
        diversion_time:  diversion._duration,
        diversion_stdev: diversion._stddev,
        name:            diversion._name,
        description:     diversion._description
      };

      rows.push(super.toRow(proxy));
    }

    /* now convert that */

    return rows;
  }

  /** helper to insert work blocks into a scenario work blocks section, returns the full object, ready to be saved. */
  render(items: Diversion[]): any {

    /* create the data table */

    const d = this.dataTable(items);

    /* insert */

    const w: any = this.findObject('diversions', this.schemaObj);

    if (w === null) {

      this.lastError = `(render) problems finding diversions section: ${this.lastError}`;

      return null;
    }

    w['data'] = d;

    /* pass back the full rendered version, this version can be given to JSON.stringify() to save to file. */

    return this.schemaObj;
  }

}
